import React, { useState, useRef } from 'react';
import './OnboardingView.css';

const SLIDES = [
  {
    id: 'welcome',
    icon: 'trending_up',
    chips: [
      { label: '+2.4%', pos: 'chip-top-left' },
      { label: 'BUY', pos: 'chip-bottom-right' },
    ],
    title: 'Willkommen bei\nBullivo',
    subtitle: 'Smarte Handelssignale für Aktien, ETFs & Krypto – powered by KI.',
    cta: null,
  },
  {
    id: 'signals',
    icon: 'query_stats',
    chips: [
      { label: 'RSI 32', pos: 'chip-top-right' },
      { label: 'STARK', pos: 'chip-bottom-left' },
    ],
    title: 'Signale die\nwirklich zählen',
    subtitle: 'Unser Algorithmus analysiert RSI, Momentum, Volumen, Analysten & News-Sentiment – und liefert dir klare Kauf- oder Verkaufssignale.',
    cta: null,
  },
  {
    id: 'features',
    icon: 'notifications_active',
    chips: [
      { label: 'Signal: BUY', pos: 'chip-top-left' },
      { label: 'MU +14%', pos: 'chip-bottom-right' },
    ],
    title: 'Immer am\nrichtigen Moment',
    subtitle: 'Beobachte deine Favoriten in der Watchlist. Wir benachrichtigen dich sobald sich etwas tut.',
    cta: null,
  },
  {
    id: 'disclaimer',
    icon: 'balance',
    chips: [],
    title: '',
    subtitle: null,
    cta: 'Verstanden – App starten',
  },
];

const DISCLAIMER_TEXT = `Bullivo stellt keine Anlageberatung dar und ersetzt keine professionelle Finanzberatung.

Alle angezeigten Signale werden algorithmisch generiert und dienen ausschließlich zur Information. Sie sind keine Empfehlung zum Kauf oder Verkauf von Wertpapieren.

Investieren in Wertpapiere birgt Risiken, einschließlich des Verlusts des eingesetzten Kapitals. Vergangene Performance ist kein Indikator für zukünftige Ergebnisse.

Mit der Nutzung von Bullivo bestätigst du, dass du diese Hinweise gelesen und verstanden hast.`;

function SlideIllustration({ icon, chips }) {
  return (
    <div className="ob-illustration">
      {/* Concentric rings */}
      <div className="ob-ring ob-ring-3" />
      <div className="ob-ring ob-ring-2" />
      <div className="ob-ring ob-ring-1" />

      {/* Icon container */}
      <div className="ob-icon-wrap">
        <span className="material-symbols-rounded ob-icon">{icon}</span>
      </div>

      {/* Floating chips */}
      {chips.map((chip, i) => (
        <div key={i} className={`ob-chip ${chip.pos}`}>
          {chip.label}
        </div>
      ))}
    </div>
  );
}

export default function OnboardingView({ onComplete }) {
  const [current, setCurrent] = useState(0);
  const [accepted, setAccepted] = useState(false);
  const startXRef = useRef(null);

  const isLast = current === SLIDES.length - 1;

  const next = () => {
    if (isLast) {
      if (accepted) onComplete();
    } else {
      setCurrent(c => c + 1);
    }
  };

  const handleTouchStart = (e) => {
    startXRef.current = e.touches[0].clientX;
  };

  const handleTouchEnd = (e) => {
    if (startXRef.current === null) return;
    const diff = startXRef.current - e.changedTouches[0].clientX;
    if (diff > 50 && !isLast) setCurrent(c => c + 1);
    if (diff < -50 && current > 0) setCurrent(c => c - 1);
    startXRef.current = null;
  };

  const slide = SLIDES[current];

  return (
    <div
      className="onboarding"
      onTouchStart={handleTouchStart}
      onTouchEnd={handleTouchEnd}
    >
      {/* Skip */}
      <div className="onboarding-skip">
        {!isLast && (
          <button onClick={() => setCurrent(SLIDES.length - 1)}>
            Überspringen
          </button>
        )}
      </div>

      {/* Illustration */}
      <div className={`ob-illustration-area${isLast ? ' ob-compact' : ''}`}>
        <SlideIllustration icon={slide.icon} chips={slide.chips} />
      </div>

      {/* Content */}
      <div className="onboarding-content">
        {slide.title && (
          <h1 className="onboarding-title">
            {slide.title.split('\n').map((line, i) => (
              <span key={i}>{line}<br /></span>
            ))}
          </h1>
        )}

        {slide.subtitle && (
          <p className="onboarding-subtitle">{slide.subtitle}</p>
        )}

        {isLast && (
          <div className="onboarding-disclaimer">
            <p>{DISCLAIMER_TEXT}</p>
            <label className="onboarding-accept">
              <input
                type="checkbox"
                checked={accepted}
                onChange={e => setAccepted(e.target.checked)}
              />
              <span>Ich habe den Haftungsausschluss gelesen und akzeptiere ihn.</span>
            </label>
          </div>
        )}
      </div>

      {/* Footer */}
      <div className="onboarding-footer">
        <div className="onboarding-dots">
          {SLIDES.map((_, i) => (
            <button
              key={i}
              className={`onboarding-dot${i === current ? ' active' : ''}`}
              onClick={() => setCurrent(i)}
              aria-label={`Slide ${i + 1}`}
            />
          ))}
        </div>

        <button
          className={`onboarding-cta${isLast && !accepted ? ' disabled' : ''}`}
          onClick={next}
          disabled={isLast && !accepted}
        >
          {isLast ? slide.cta : 'WEITER'}
        </button>
      </div>
    </div>
  );
}
